import { useQuery } from '@tanstack/react-query';
import { goalStatusesApi, GoalStatusDto } from '../api/goalStatuses';

export const useGoalStatuses = () => {
  return useQuery<GoalStatusDto[]>({
    queryKey: ['goalStatuses'],
    queryFn: () => goalStatusesApi.list(),
  });
};
